import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

import {
  environmentalChecklistItem,
  environmentalChecklistItemWithTicket,
} from "../../../../schemas";

export const dayEnvChecklistFreezerSchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  freezerTempLog: environmentalChecklistItem,
  freezerDefrosted: environmentalChecklistItem,
  freezerUnder: environmentalChecklistItem,
  freezerTop: environmentalChecklistItem,
  freezerRepair: environmentalChecklistItemWithTicket,
  freezerComment: z.string().optional(),
});
